export enum GetEndPoints {
    CustomerId = '/customers/{customer-id}',
    Customers = '/customers',
    CounterpartId = '/counterparts/{counterpart-id}',
    Counterpart = '/counterparts',
    Inbox = '/inbox',
    Roles = '/roles',
    UserId = '/users/{user-id}',
    Users = '/users',
    Agreements = '/agreements',
    AgreementId = '/agreements/{agreement-id}',
    AgreementNoteReminders = '/agreements/reminders',
    AgreementTypes = '/agreements/types',
    Download = '/agreements/{agreement-id}/download',
    //DownloadTempFile = '/agreements/download/temp/{temp-path}',
    DownloadTempFile = '/agreements/download/temp',
    ListTypeItem = '/agreements/listitems/{type}',
    AllListTypeItem = '/agreements/listitems',
    CommitmentPeriodTypes = '/agreements/commitmentperiodtypes',
    AgreementCalendarInfo = '/agreements/calendarinfo',
    Dashboard = '/dashboard',
    TemplateByType = '/templates/type/{type-id}',
    Subscription = '/subscriptions',
    GenerateMetaData = '/agreements/generatemetadata/{metadata-id}',
    Inventories = '/agreements/inventories',
    Activities = '/dashboard/activities',
    UserProfileId = '/users/{user-id}/profile',
    AIGenerate = '/ai/generate/{id}',
    EsgReport = '/counterparts/{id}/esg-report'
}

export enum PostEndPoints {
    Agreements = '/agreements',
    Customers = '/customers',
    Counterpart = '/counterparts',
    Login = '/auth/login',
    RefershToken = '/auth/refresh-token',
    User = '/users',
    MoveResponsible = '/users/moveresponsible',
    GenerateWriteSas = '/agreements/generateWriteSas',
    Upload = '/agreements/upload/temp',
    GenerateMetaData = '/agreements/generatemetadata',
    ListTypeItem = '/agreements/listitems/{type}',
    SendPasswordResetCode = '/users/sendpasswordresetcode',
    ResetPassword = '/users/resetpassword',
    Subscription = '/subscriptions',
    RenegotiateAgreement = '/agreements/renegotiate',
    AIGenerate = '/ai/generate',
    EsgReport = '/counterparts/{id}/esg-report'
}

export enum PutEndPoints {
    Agreements = '/agreements/{agreement-id}',
    AgreementPeriods = '/agreements/{agreement-id}/periods',
    AgreementReminder = '/agreements/{agreement-id}/reminder',
    AgreementPayment = '/agreements/{agreement-id}/payment',
    AgreementNoteReminders = '/agreements/{agreement-id}/notereminders',
    AgreementFiles = '/agreements/{agreement-id}/attachments',
    Customer = '/customers/{customer-id}',
    Counterpart = '/counterparts/{counterpart-id}',
    User = '/users/{user-id}',
    AgreementRealEstate = '/agreements/{agreement-id}/realestate',
    AgreementRental = '/agreements/{agreement-id}/rental',
    AgreementInventory = '/agreements/{agreement-id}/inventory'
}

export enum DeleteEndPoints {
    Agreements = '/agreements',
    Customer = '/customers/{customer-id}',
    Counterpart = '/counterparts/{counterpart-id}',
    User = '/users/{user-id}',
    Inbox = '/inbox/{inbox-id}',
    ListType = '/agreements/listitems/{type}'
}
